import { Box, Chip, type ChipProps } from "@mui/material";

type TabsProps<T extends string = string> = {
	value: T;
	active: boolean;
	label: string;
	color: ChipProps["color"];
	onClick: (value: T) => void;
};

export const ChipFilterTab = <T extends string>(props: TabsProps<T>) => {
	const { value, color, label, active, onClick } = props;
	return (
		<Box onClick={() => onClick(value)}>
			<Chip
				label={label}
				size="medium"
				variant={active ? "filled" : "outlined"}
				color={color}
				sx={{ cursor: "pointer", userSelect: "none" }}
			/>
		</Box>
	);
};
